import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [display, setDisplay] = useState('0');
  const [formula, setFormula] = useState('');
  const [currentValue, setCurrentValue] = useState('0');
  const [prevValue, setPrevValue] = useState(null);
  const [operation, setOperation] = useState(null);
  const [waitingForOperand, setWaitingForOperand] = useState(false);

  // Handle number input
  const inputNumber = (num) => {
    if (waitingForOperand) {
      setDisplay(String(num));
      setWaitingForOperand(false);
    } else {
      setDisplay(display === '0' ? String(num) : display + num);
    }
  };

  // Handle decimal point
  const inputDecimal = () => {
    if (waitingForOperand) {
      setDisplay('0.');
      setWaitingForOperand(false);
    } else if (display.indexOf('.') === -1) {
      setDisplay(display + '.');
    }
  };

  // Handle clear
  const clear = () => {
    setDisplay('0');
    setFormula('');
    setCurrentValue('0');
    setPrevValue(null);
    setOperation(null);
    setWaitingForOperand(false);
  };

  // Handle operations
  const performOperation = (nextOperation) => {
    const inputValue = parseFloat(display);

    if (prevValue === null) {
      setPrevValue(inputValue);
    } else if (operation) {
      const currentValue = prevValue || 0;
      const newValue = calculate(currentValue, inputValue, operation);

      setPrevValue(newValue);
      setDisplay(String(newValue));
    }

    setWaitingForOperand(true);
    setOperation(nextOperation);
    setFormula(display + ' ' + nextOperation + ' ');
  };

  // Calculate result
  const calculate = (firstValue, secondValue, operation) => {
    switch (operation) {
      case '+':
        return firstValue + secondValue;
      case '-':
        return firstValue - secondValue;
      case '*':
        return firstValue * secondValue;
      case '/':
        return firstValue / secondValue;
      default:
        return secondValue;
    }
  };

  // Handle equals
  const handleEquals = () => {
    const inputValue = parseFloat(display);

    if (prevValue !== null && operation) {
      const result = calculate(prevValue, inputValue, operation);
      
      setDisplay(String(result));
      setFormula(formula + display + ' = ' + result);
      setPrevValue(null);
      setOperation(null);
      setWaitingForOperand(true);
    }
  };

  // Handle keyboard input
  useEffect(() => {
    const handleKeyPress = (event) => {
      const { key } = event;
      
      if (key >= '0' && key <= '9') {
        inputNumber(parseInt(key));
      } else if (key === '.') {
        inputDecimal();
      } else if (key === '+') {
        performOperation('+');
      } else if (key === '-') {
        performOperation('-');
      } else if (key === '*') {
        performOperation('*');
      } else if (key === '/') {
        event.preventDefault();
        performOperation('/');
      } else if (key === 'Enter' || key === '=') {
        event.preventDefault();
        handleEquals();
      } else if (key === 'Escape' || key === 'c' || key === 'C') {
        clear();
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [display, waitingForOperand, operation, prevValue]);

  return (
    <div className="calculator">
      <div id="display" className="display">
        <div className="formula">{formula}</div>
        <div className="current">{display}</div>
      </div>
      
      <div className="keypad">
        <button id="clear" className="clear" onClick={clear}>
          AC
        </button>
        
        <button id="divide" className="operator" onClick={() => performOperation('/')}>
          /
        </button>
        
        <button id="multiply" className="operator" onClick={() => performOperation('*')}>
          ×
        </button>
        
        <button id="seven" className="number" onClick={() => inputNumber(7)}>
          7
        </button>
        
        <button id="eight" className="number" onClick={() => inputNumber(8)}>
          8
        </button>
        
        <button id="nine" className="number" onClick={() => inputNumber(9)}>
          9
        </button>
        
        <button id="subtract" className="operator" onClick={() => performOperation('-')}>
          -
        </button>
        
        <button id="four" className="number" onClick={() => inputNumber(4)}>
          4
        </button>
        
        <button id="five" className="number" onClick={() => inputNumber(5)}>
          5
        </button>
        
        <button id="six" className="number" onClick={() => inputNumber(6)}>
          6
        </button>
        
        <button id="add" className="operator" onClick={() => performOperation('+')}>
          +
        </button>
        
        <button id="one" className="number" onClick={() => inputNumber(1)}>
          1
        </button>
        
        <button id="two" className="number" onClick={() => inputNumber(2)}>
          2
        </button>
        
        <button id="three" className="number" onClick={() => inputNumber(3)}>
          3
        </button>
        
        <button id="equals" className="equals" onClick={handleEquals}>
          =
        </button>
        
        <button id="zero" className="number zero" onClick={() => inputNumber(0)}>
          0
        </button>
        
        <button id="decimal" className="number" onClick={inputDecimal}>
          .
        </button>
      </div>
    </div>
  );
}

export default App;